import mp_loader from "./mp_loader.svg?url"
export default {
  mp_loader
}
